import { Icon } from '@celito.clients/shared';
import {
  Button,
  Menu,
  MenuItem,
  MenuItemProps,
  MenuList,
  MenuPopover,
  MenuTrigger,
  SelectTabData,
  Tooltip,
  useIsOverflowItemVisible,
  useOverflowMenu,
} from '@fluentui/react-components';

import { ITabOverflow, OverflowMenuProps } from './overflow-menu.model';
import { useOverflowTabMenuStyles } from './overflow-menu.styles';

type OverflowMenuItemProps = {
  tab: ITabOverflow;
  onClick: MenuItemProps['onClick'];
};

const OverflowMenuItem = (props: OverflowMenuItemProps) => {
  const { tab, onClick } = props;
  const isVisible = useIsOverflowItemVisible(tab.name);

  const styles = useOverflowTabMenuStyles();

  if (isVisible) {
    return null;
  }

  return (
    <MenuItem key={tab.name} onClick={onClick} disabled={tab.disabled}>
      <Tooltip relationship="label" content={tab.label}>
        <div className={styles.label}>{tab.label}</div>
      </Tooltip>
    </MenuItem>
  );
};

export const OverflowMenuView = ({
  menuHiddenRef,
  onTabSelect,
  tabs,
}: OverflowMenuProps) => {
  const { ref, isOverflowing } = useOverflowMenu<HTMLButtonElement>();

  const styles = useOverflowTabMenuStyles();

  if (!isOverflowing) {
    return null;
  }

  return (
    <Menu hasIcons>
      <MenuTrigger disableButtonEnhancement>
        <Button
          appearance="transparent"
          className={styles.menuButton}
          ref={ref}
          icon={<Icon iconName="MoreHorizontal24Regular" />}
          role="tab"
        />
      </MenuTrigger>
      <MenuPopover>
        <MenuList className={styles.menu} ref={menuHiddenRef}>
          {tabs?.map((tab) => (
            <OverflowMenuItem
              key={tab.name}
              onClick={(_) =>
                onTabSelect(_, { value: tab.name } as unknown as SelectTabData)
              }
              tab={tab}
            />
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
